import { Link } from "react-router-dom";
import AdminControlNavigation from "./AdminControlNavigation";

export default function AdminManagementLayout({ active, eyebrow, title, children }) {
  return (
    <main className="admin-page admin-management-page" data-testid={`admin-${active}-page`}>
      <section className="portal-header admin-management-header">
        <div>
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
        </div>
        <Link className="button button--outline" to="/investor-portal" data-testid={`admin-${active}-portal-link`}>Investor portal</Link>
      </section>
      <AdminControlNavigation active={active} />
      {children}
    </main>
  );
}